module.exports = __webpack_public_path__ + "static/media/9.dedc2c15.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/9.svg
// module id = 414
// module chunks = 14